import {chain} from "@Common/utils/fs";

import {addVector}       from "../common/add-vector";
import {centerOfSize}    from "../common/center-of-size";
import {getContainRatio} from "../common/get-contain-ratio";
import {multiplySize}    from "../common/multiply-size";
import {multiplyVector}  from "../common/multiply-vector";
import {subtractVector}  from "../common/subtract-vector";

import {sizeToVector} from "./size-to-vector";

export const calFrameLoc = ({desktopSize, vpSize, frame, mobile}) => {
    const ratio = chain(
        (() => {
            const padding = Math.min(
                Math.min(
                    desktopSize.width,
                    desktopSize.height,
                ) * (mobile ? .2 : .1),
                mobile ? 50 : 20,
            );
            return getContainRatio(
                {
                    width: desktopSize.width - padding * 2,
                    height: desktopSize.height - padding * 2,
                },
                vpSize,
            );
        })(),
        (ratio) => ratio * frame.scale,
    );
    const size = multiplySize(vpSize, ratio);

    const center = chain(
        centerOfSize(desktopSize),
        (_) => addVector(_, frame.offset),
    );
    return {
        ratio,
        size,
        center,
        start: chain(
            center,
            (_) => subtractVector(_, chain(
                sizeToVector(size),
                (_) => multiplyVector(_, 1 / 2),
            )),
        ),
    };
};

